import React, { useContext, useEffect, useRef, useState } from "react";
import OTPInput from "otp-input-react";
import { Toast } from "primereact/toast";

// context
import AuthContext from "../../contexts/authContext";

import { apiURL, getData, patchData, postData } from "../../services/API";
import NoticeMsg from "../../components/shared/NoticeMsg";
import { idGenerator, toFarsiNumber } from "../../helper/helper";
import Loading from "../../components/shared/Loading";
import { CheckError } from "./checkError";

// forms & api
import Input from "../../components/shared/Form/Input";
import config from "./config.json";
import { useForm } from "react-hook-form";
import { UserData } from "../../contexts/UserInfoContext";
import { useNavigate } from "react-router-dom";

const Verification = ({
  registered,
  data,
  setStepNum,
  phoneNumber,
  resetPassword,
  setIsComplite,
}) => {
  const {
    api_url: {
      p_verify_code,
      p_change_pass_code,
      p_change_pass,
      g_user_profile,
    },
  } = config;

  const navigate = useNavigate();

  const { register, getValues } = useForm();

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);
  const [wrongCode, setWrongCode] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [counter, setCounter] = useState(30);
  const [send, setSend] = useState(true);
  const [resendLoading, setResendLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [progress, setProgress] = useState("0%");
  const [message, setMessage] = useState("");

  const toastLogin = useRef(null);
  const reSendBtn = useRef();

  const authContext = useContext(AuthContext);
  const { setUser } = useContext(UserData);

  const { phone_number } = authContext.userInfo;

  useEffect(() => {
    reSendBtn.current.disabled = true;

    // show password
    const passwordField = document.querySelector(".password-filed-eye");
    if (passwordField) {
      if (showPassword) {
        passwordField.type = "text";
      } else {
        passwordField.type = "password";
      }
    }

    // reset counter & errors
    if (registered === null) {
      setCode("");
      setErr(false);
      setCounter(30);
    }

    // reSend code counter
    let timer;
    if (registered === false) {
      timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    }

    if (counter === 0) reSendBtn.current.disabled = false;

    return () => clearInterval(timer);
  }, [counter, registered, showPassword]);

  // submit form
  const submitHandler = () => {
    if (!resetPassword) {
      if (code) {
        setLoading(true);
        postData(p_verify_code.url, { vcode: code, phone_number }, false)
          .then((res) => {
            authContext.userVerify(res.data, code);
            setStepNum(3);
            setIsComplite(true);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            setErr(true);
            setErrMsg(error.response?.data.message);
          });
      } else {
        setErr(true);
        setErrMsg("کد تایید را وارد کنید.");
      }
    } else {
      if (password && code) {
        setLoading(true);
        setErr(false);

        postData(
          p_change_pass.url,
          { vcode: code, phone_number, password },
          false
        )
          .then((res) => {
            authContext.userPasswordRecovery(res.data);
            // setStepNum(3);
            // toast message
            toastLogin.current.show({
              severity: "success",
              summary: "رمز عبور شما با موفقیت تغییر کرد",
              detail: "در حال انتقال به پنل کاربری...",
              life: 3500,
            });

            // get user data
            getData(g_user_profile.url, {}, true)
              .then((res) => {
                setLoading(false);
                setUser(res.data);
                if (res.data.user.name.includes("Admin")) {
                  navigate("/admin");
                } else {
                  navigate("/user");
                }
              })
              .catch((err) => {});
          })
          .catch((error) => {
            setLoading(false);
            setErr(true);
            setErrMsg(error.response?.data.message);
          });
      } else {
        setLoading(false);
        setErr(true);
        setErrMsg("کد تایید و رمز عبور را وارد کنید.");
      }
    }
  };

  const verify = () => {
    if (code.length === 5 && send && !resetPassword) {
      submitHandler();
      setSend(false);
    }
  };

  verify();

  const resendVerficationCode = () => {
    setResendLoading(true);

    postData(
      !resetPassword ? "/user/auth" : p_change_pass_code.url,
      { phone_number },
      false
    )
      .then((res) => {
        setCounter(30);
        setResendLoading(false);
        setErr(false);
      })
      .catch((err) => {
        setErr(false);
        setErrMsg(err.response?.data.message);
        setResendLoading(false);
      });
  };

  const onChangeHandler = (passValue) => {
    setErrMsg("");
    setErr(false);

    const strengthCheck = {
      length: 0,
      hasLowerCase: false,
      hasUpperCase: false,
      hasDigits: false,
      hasSpecialChar: false,
    };

    strengthCheck.length = passValue.length >= 6 ? true : false;
    strengthCheck.hasLowerCase = /[a-z]+/.test(passValue);
    strengthCheck.hasUpperCase = /[A-Z]+/.test(passValue);
    strengthCheck.hasDigits = /[0-9]+/.test(passValue);
    strengthCheck.hasSpecialChar = /[^A-Za-z0-9]+/.test(passValue);

    const verifiedList = Object.values(strengthCheck).filter((value) => value);

    const strength =
      verifiedList.length === 5
        ? "رمز عبور شما قوی است"
        : verifiedList.length >= 2
        ? "رمز عبور شما متوسط است"
        : "رمز عبور شما ضعیف است";

    setPassword(passValue);
    setProgress(`${(verifiedList.length / 5) * 100}%`);
    setMessage(strength);
  };

  const getStrengthColor = (message) => {
    if (message === "رمز عبور شما قوی است") return "#3FBB60";
    if (message === "رمز عبور شما متوسط است") return "#FE804D";
    return "#FF0054";
  };

  return (
    <div className="">
      <Toast ref={toastLogin} />

      {data.data && !err ? (
        <div className="mb-3">
          <NoticeMsg notice={"success"} msg={data.data.message} />
        </div>
      ) : (
        err && (
          <div>
            <NoticeMsg msg={errMsg} notice={"error"} />
          </div>
        )
      )}

      <form
        // onSubmit={submitHandler}
        className={`verify-code flex flex-col gap-7 mt-6 transition-all duration-300`}
      >
        {/* otp sms input */}
        <div className="flex flex-col gap-3">
          <label className="font-semibold text-slate-800">
            کد تایید را وارد کنید
          </label>
          <OTPInput
            value={code}
            onChange={setCode}
            autoFocus
            OTPLength={5}
            otpType="number"
            className="flex justify-between items-center flex-row-reverse"
            inputClassName={`otp-input-custom border rounded-2xl text-xl outline-none focus:ring ring-[#2f52ef] focus:shadow-lg focus:shadow-blue-200 transition-all duration-300`}
          />
          {errMsg?.code && (
            <span className="text-red-600 text-sm">{errMsg.code[0]}</span>
          )}
        </div>

        {/* reset password input */}
        {resetPassword && (
          <div className="w-full flex flex-col gap-2">
            <label>رمز عبور</label>
            <div className="relative">
              {/* {passwordInput} */}
              <input
                type={showPassword ? "text" : "password"}
                placeholder={"رمز عبور خود را وارد کنید"}
                className={`${
                  errMsg?.password
                    ? "ring-1 ring-red-600 bg-red-50 focus:ring-red-600"
                    : "ring-[#2f52ef] focus:ring-[#2f52ef] bg-gray-100"
                } w-full h-[50px] rounded-xl px-4 outline-none focus:ring-2 focus:!bg-white focus:shadow-lg focus:shadow-[#2f52ef5a] transition-all duration-200`}
                value={password}
                onChange={({ target }) => onChangeHandler(target.value)}
              />

              <div
                onClick={() => setShowPassword(!showPassword)}
                className="cursor-pointer outline-none border-none absolute top-2/4 -translate-y-2/4 left-3"
              >
                {showPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-6 h-6 stroke-[#2f52ef]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-6 h-6 stroke-[#2f52ef]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                )}
              </div>
            </div>
            {errMsg?.password && (
              <span className="text-red-600 text-sm">{errMsg.password[0]}</span>
            )}

            <span className="text-gray-600 text-xs">
              رمز عبور باید شامل حروف بزرگ و کوچک انگلیسی، اعداد و کاراکتر های
              خاص(#$%&...) باشد.
            </span>

            {password.length > 0 && (
              <div className="w-full flex flex-col gap-1 mt-1">
                {/* progress bar */}
                <div className="w-full bg-gray-50 h-2 rounded-full">
                  <div
                    style={{
                      width: progress,
                      backgroundColor: getStrengthColor(message),
                    }}
                    className="h-full rounded-full transition-all"
                  ></div>
                </div>
                <p
                  style={{ color: getStrengthColor(message) }}
                  className="text-sm"
                >
                  {message}
                </p>
              </div>
            )}
          </div>
        )}
      </form>

      {/* resend code timer */}
      <div className="flex justify-center gap-2 my-7 animate-delay-2">
        {counter > 0 && (
          <span className="w-7 h-7 flex justify-center items-center">
            {toFarsiNumber(`0:${counter}`)}
          </span>
        )}
        <button
          ref={reSendBtn}
          onClick={resendVerficationCode}
          className="w-fit text-sm disabled:opacity-50 text-[#2f52ef]"
        >
          {resendLoading ? <Loading /> : "دریافت مجدد کد تایید"}
        </button>
      </div>

      <button
        className="bg-blue disabled:opacity-50 animate-delay-4 text-white w-full h-11 rounded-lg shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all duration-300"
        onClick={submitHandler}
      >
        {loading ? <Loading color={"before:bg-white"} /> : "تایید و ادامه"}
      </button>
    </div>
  );
};

export default Verification;
